import { Navigate, Outlet, useLocation } from "react-router-dom"
import { Spinner } from "@/components/ui/spinner"
import { useAuth } from "@/contexts/AuthContext"

// Guard area /admin — wajib login DAN role administrator
export function AdminRoute() {
  const { user, isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-8 text-primary" />
      </div>
    )
  }

  if (!isAuthenticated) {
    const redirect = `${location.pathname}${location.search}`
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />
  }

  if (user?.role !== "administrator") {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 px-6 text-center">
        <h1 className="text-2xl font-black">Akses Ditolak</h1>
        <p className="text-muted-foreground text-sm">
          Halaman ini khusus administrator. Akun Anda: <span className="font-bold">{user?.role}</span>.
        </p>
        <a href="/" className="text-primary font-bold hover:underline">Kembali ke Beranda</a>
      </div>
    )
  }

  return <Outlet />
}
